<div class="container-fluid">
  <div class="card">
    <div class="title">
      <div>마케팅 이용 동의</div>
    </div>
    <div class="card-body top" *ngIf="marketing">
      <div class="content">{{ marketing }}</div>
    </div>
  </div>
</div>
